import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 获取banner列表
  bannerList(data) {
    const params = data
    return request({
      url: urlParams + '/banner/list',
      type: 'get',
      params: params
    })
  },  
  // banner新增修改
  bannerAddup(data) {
    const params = data
    return request({
      url: urlParams + '/banner/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },  
  // banner新增状态
  bannerStatus(data) {
    const params = data
    return request({
      url: urlParams + '/banner/updateStatus',
      type: 'post',
      params: params
    })
  },    
  // 删除
  bannerDel(data) {
    const params = data
    return request({
      url: urlParams + '/banner/del',
      type: 'post',
      params: params
    })
  },   
}